import React, { useState } from 'react';
import { User , KeyRound , Copy, FileText, Check, School, Monitor, BookOpen, MapPin } from 'lucide-react';
import EditableField from '../../../../../components/EditableFields';
import useClientesModel from '../../../../../modelos/Clientes/modeloClientes';

const HeaderProPlataforma = ({cliente,nombreEmpresaReal}) => {
  const {
    updateCliente,
  } = useClientesModel();

  const [passwordCopied, setPasswordCopied] = useState(false);
  const handleCopyPassword = () => {
      navigator.clipboard.writeText(cliente.infoPlataforma.contrasena);
      setPasswordCopied(true);
      setTimeout(() => setPasswordCopied(false), 2000); // El feedback desaparece después de 2 segundos
  };

  const handleSaveInfoCliente = (field, value) =>{
  
    updateCliente(cliente.numero,nombreEmpresaReal,field,value,'field');
  
  }
  
  //info del cliente
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8 mb-6">
          {/* --- ENCABEZADO --- */}
          <div className="flex flex-col md:flex-row items-start justify-between pb-6 border-b border-gray-200">
            <div>
              <h2 className="text-3xl font-bold text-gray-800">
                #{cliente.numero} - {cliente.nombreCliente}
              </h2>
              <p className="text-lg text-gray-500 mt-1">{cliente.nombrecompletoCliente}</p>
            </div>
            <span className="mt-4 md:mt-0 inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-green-100 text-green-800 shrink-0">
              <Check className="h-4 w-4 mr-2" />
              Pro Plataforma
            </span>
          </div>

          {/* --- DETALLES EN CUADRÍCULA --- */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 mt-6">
            
            {/* Info Académica */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><BookOpen className="h-4 w-4 mr-2" /> Carrera</p>
              <p className="text-md text-gray-800">{cliente.carrera || 'No especificada'}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><School className="h-4 w-4 mr-2" /> Universidad</p>
              <p className="text-md text-gray-800">{cliente.universidad || 'No especificada'}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><MapPin className="h-4 w-4 mr-2" /> Procedencia</p>
              <p className="text-md text-gray-800">{cliente.procedencia || 'No especificada'}</p>
            </div>
            
            {/* Credenciales de Plataforma */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><Monitor className="h-4 w-4 mr-2" /> Plataforma</p>
              <p className="text-md text-gray-800">{cliente.infoPlataforma.plataforma || 'No especificada'}</p>
            </div>
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><User className="h-4 w-4 mr-2" /> Usuario</p>
              <p className="text-md text-gray-800">{cliente.infoPlataforma.usuario || 'No especificado'}</p>
            </div>
            
            {/* ⭐ Campo de Contraseña Seguro */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 flex items-center"><KeyRound className="h-4 w-4 mr-2" /> Contraseña</p>
              <div className="flex items-center space-x-2">
                <p className="text-md text-gray-800 font-mono">{cliente.infoPlataforma.contrasena}</p>
                <button 
                  onClick={handleCopyPassword}
                  className={`flex items-center px-3 py-1 text-xs font-medium rounded-md transition-colors duration-200 ${
                    passwordCopied 
                      ? 'bg-green-600 text-white' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                >
                  {passwordCopied ? <Check className="h-3 w-3 mr-1" /> : <Copy className="h-3 w-3 mr-1" />}
                  {passwordCopied ? 'Copiado' : 'Copiar'}
                </button>
              </div>
            </div>

          </div>

          {/* --- CONTEXTO DEL CLIENTE --- */}
          <div className="mt-8 pt-6 border-t border-gray-200">
              <h3 className="text-sm font-medium text-gray-500 flex items-center mb-2"><FileText className="h-4 w-4 mr-2" /> Contexto del Cliente</h3>
              <p className="text-md text-gray-700 bg-gray-50 p-4 rounded-lg border border-gray-200">
                <EditableField
                    field="contextoCliente"
                    label="Notas del cliente"
                    value={cliente.contextoCliente}
                    type="text"
                    isAdmin={true}
                    onSave={handleSaveInfoCliente}
                  />
              </p>
            </div>

          {/* --- ESTADO DE COTIZACION --- */}
          <EditableField
            field="estadoClienteEspecial"
            label="Estado cliente especial COTIZANDO, COTIZACION_PASADA //CONTACTO_CLIENTE //NO_ACCESO_PLATAFORMA COTIZACION_LISTA" 
            value={cliente.estadoClienteEspecial || ''}
            type="text"
            isAdmin={true}
            onSave={handleSaveInfoCliente}
          />

          {cliente.estadoClienteEspecial === "TRABAJANDO" && (
            <EditableField
              field="estadoTrabajoUnadCurso"
              label="ESTADO DE CLIENTE , TRABAJANDO , ESPERANDO_PAGO" 
              value={cliente.estadoTrabajoUnadCurso || ''}
              type="text"
              isAdmin={true}
              onSave={handleSaveInfoCliente}
            />
          )}

        </div>
  )
  
}

export default HeaderProPlataforma
